<template>
    <div>
        <!-- Begin Page Content -->
        <div class="Medicines">
            <div class="row">
                <div class="col-12">
                    <div class="bg-white border-radius-5 p-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <h2>Your list of Medication</h2>
                            <a href="#"><i class="icon icon-plus"></i>Add More Medicine</a>
                        </div>
                        <div class="table-responsive Diebetes-list-section">
                            <table class="table Medicine-list mb-0 border-0" border="0" cellspacing="0" cellpadding="0">
                                <thead>
                                    <tr>
                                        <th>Medicine Name</th>
                                        <th>Dosage</th>
                                        <th>Duration</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>1. Ceruvin 75</span></td>
                                        <td>2 times(Morning and Evening )</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product">Analyze your medicine</router-link ></td>
                                    </tr>
                                    <tr>
                                        <td><span>2. Azulix O MF Forte </span></td>
                                        <td>1 Time (Morning before brekfast)</td>
                                        <td>10 Days, Total Tablet : 20</td>
                                        <td><router-link to="/prescription-product">Analyze your medicine</router-link ></td>
                                    </tr>
                                    <tr>
                                        <td><span>3. Neksium 40</span></td>
                                        <td>1 Time (Before Lunch)</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product">Analyze your medicine</router-link ></td>
                                    </tr>
                                    <tr>
                                        <td><span>4. Tazloc-20, </span></td>
                                        <td>2 times(Morning and Evening )</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product">Analyze your medicine</router-link ></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex justify-content-center align-items-center mt-5 my-4">
                            <router-link class="btn btn-blue Create-Prescription mr-4" to="/prescription-list">Create Prescription List</router-link>
                            <router-link to="/prescription-medicine-order" class="prescription-order">Order all as per Prescription List</router-link >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid medical-records called-forward mt-4">
            <div class="row mr-0">
                <div class="col-lg-12 col-md-12 col-sm-12 mb-4 pl-4">
                    <div class="bg-white border-radius-5 p-5">
                        <div class="row no-gutters justify-content-center">
                            <div class="col-md-4 text-center">
                                <figure class="mb-4">
                                    <img src="../../../../static/website/images/stopwatch.svg" alt="" />
                                </figure>
                                <h4 class="mb-3">Please wait to be called forward.</h4>
                                <p>Prescription waiting times are longer than usual. Please consider leaving your Prescription & Coming back later.</p>
                                <p>Thank you for your Patience</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Medicines",
        data() {
            return {};
        },
        created(){
           this.pageName('Medicines')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/medicines/medicines.vue